import { z } from 'zod';

export const ExplicitConsentMethodSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    method: z.string().min(1),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateExplicitConsentMethodSchema = ExplicitConsentMethodSchema.omit({ id: true });
export const UpdateExplicitConsentMethodSchema = ExplicitConsentMethodSchema;
export const ExplicitConsentMethodFormSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "form.validation.nameRequired"),
    description: z.string().optional(),
});